import axios from 'axios';
import config from "./config";
import router from "@/router";


const server=axios.create(config);
server.interceptors.request.use((config) => { /* 请求之前拦截器 */
    // config.header = {
    //     ...config.header
    // }
    if(config.custom.auth){
        let token=config.header.token;
        if (!token) {
            // console.log('token 不存在')
            router.push('/register')
            return ;
        }
        config.headers.token = token
    }
    // console.log('请求参数：'+JSON.stringify(config));
    return config
})
server.interceptors.response.use(
    res => {
        // console.log('返回结果：'+JSON.stringify(res));
        if (res) {


            return res;
        }
    },
    err => {

        // console.log('返回错误1：'+JSON.stringify(err.response));
        if(err.response.data.status==70105){
            // console.log('返回错误：'+err.response.data.message);
            alert("登录过期，请重新登录！");
            router.push('/');
            return;
        }
        // this.$message({
        //     showClose: true,
        //     message: '请重新登录！',
        //     type: 'error'
        // });
        // that.$router.push('/register')
        return Promise.reject(err);
    }
);



export default server;
